import {z} from 'zod';

import {parseJSON} from 'shared/web';

const ServiceOrderDataSchema = z.object({
  title: z.string().nullish(),
  number: z.string().nullish(),
  variant: z.string().nullish(),
  note: z.string().nullish(),
  damageCode: z.string().nullish(),
  eskulabAuthorizationNumber: z.string().nullish(),
  eskulabStatus: z.string().nullish(),
  eskulabValidityDate: z.string().nullish(),
  eskulabValidityMileageInKm: z.number().nullish(),
  groundingReason: z.string().nullish(),
});

export const getServiceOrderData = (dataJson: string) => {
  const data = parseJSON(dataJson, ServiceOrderDataSchema);
  return data;
};
